import React, {Component} from 'react';
import './RmDialog.css';
import PropTypes from 'prop-types';

export default class RmDialog extends Component {
    handleBaseClick(e) {
        if (e.target.className === "RmDialog") {
            if (this.props.onCloseRequested) {
                this.props.onCloseRequested(RmDialog.CLOSE_VIA_BACKGROUND_CLICK);
            }
        }
    }

    handleCloseClick() {
        if (this.props.onCloseRequested) {
            this.props.onCloseRequested(RmDialog.CLOSE_VIA_X_BUTTON);
        }
    }

    render() {
        return (
            <div className={"RmDialog"} onClick={this.handleBaseClick.bind(this)}>
                <div className={"RmDialog__box"}>

                    <div className={"RmDialog__head"}>
                        <h2 className={"RmDialog__title"}>{this.props.title}</h2>
                        <p className={"RmDialog__subtitle"}>{this.props.subtitle}</p>
                        {this.props.canClose &&
                        <a className={"RmDialog__close"} onClick={this.handleCloseClick.bind(this)}>
                            <i className={"mdi mdi-close"}/>
                        </a>
                        }
                    </div>

                    <div className={"RmDialog__inner"}>
                        {this.props.children}
                    </div>

                </div>
            </div>
        );
    }
}

RmDialog.defaultProps = {
    canClose: true
};

RmDialog.propTypes = {
    onCloseRequested: PropTypes.func,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    canClose: PropTypes.bool
};

RmDialog.CLOSE_VIA_BACKGROUND_CLICK = "bgclick";
RmDialog.CLOSE_VIA_X_BUTTON = "xbtn";



// WEBPACK FOOTER //
// ./src/Portal/Dialog/RmDialog.js